import React, { useState } from "react";
import Icon from "@components/Icon";

interface SetupGuideCollapsibleSectionProps {
    title: string;
    defaultExpanded?: boolean;
    withBottomPadding?: boolean;
    children: React.ReactNode;
}

const SetupGuideCollapsibleSection: React.FC<SetupGuideCollapsibleSectionProps> = ({
    title,
    defaultExpanded = false,
    withBottomPadding = true,
    children,
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <div className={`flex flex-col gap-2.5${withBottomPadding ? " pb-4" : ""}`}>
            <button
                type="button"
                className="flex items-center gap-2.5 px-4 text-left"
                onClick={() => setExpanded((previous) => !previous)}
                aria-expanded={expanded}
            >
                <p className="text-[14px] font-semibold leading-[22px] text-text-body">{title}</p>
                <Icon
                    name="chevron-down"
                    width={24}
                    height={24}
                    className={`shrink-0 fill-dark-60 transition-transform duration-200 ${
                        expanded ? "rotate-180" : ""
                    }`}
                />
            </button>

            {expanded ? <div className="px-4">{children}</div> : null}
        </div>
    );
};

export default React.memo(SetupGuideCollapsibleSection);
